import _ from 'underscore';

import {createFetchListActions} from 'common/actions/utils';
import AgencyApi from 'common/api/AgencyApi';
import Agency from 'common/types/Agency';


export const {
  fetchAgenciesIfNeeded,
} = createFetchListActions({
  name: 'agency',
  pluralName: 'agencies',
  api: new AgencyApi(),
  DataType: Agency,
  idProp: 'name',
  deserializer: (items) => {
    const agencies = _.filter(items, (item) => item.products.indexOf('ondemand') >= 0);
    // OnDemand expects agencies to have an id, so use the names which are unique
    return agencies.map((agency) => Object.assign({agency_id: agency.name}, agency));
  },
});



// WEBPACK FOOTER //
// ./src/ondemand/actions/agency.js